import {
  IBaseChartBuilderConfig,
  ICustomChartSettings,
  ICustomReportChart,
  ICustomReportDefinedColumn,
  ICustomReportFilter,
  MeasureReducer,
  ReportBuilderDataSourceId,
  ReportingReference,
  TemplateScope,
} from '@principle-theorem/principle-core/interfaces';
import { IBaseMeasures } from './base-measures';
import {
  ICanBeChartedProperty,
  ICanGroupMeasuresProperty,
  ICanQueryByTimestampProperty,
} from './measure-properties';

export interface IQueryableTimestamp {
  property: ICanQueryByTimestampProperty;
}

export interface IChartFilter<
  ChartSettings extends ICustomChartSettings = ICustomChartSettings,
  ChartBuilderConfig extends IBaseChartBuilderConfig = IBaseChartBuilderConfig,
> {
  id: ReportingReference;
  chart: ICustomReportChart<ChartSettings, ChartBuilderConfig>;
  groupBy: ICanGroupMeasuresProperty;
  availableInEditMode: boolean;
}

export interface IScopeDataAccessor {
  scopeMeasure: ICanBeChartedProperty;
  scopeLabelMeasure?: ICanBeChartedProperty;
}

export type ScopeDataAccessorMap = Partial<
  Record<TemplateScope, IScopeDataAccessor>
>;

export interface IReportBuilderDataSource {
  id: ReportBuilderDataSourceId;
  name: string;
  description: string;
  factTable: IBaseMeasures;
  isRetired: boolean;
  queryableTimestamps: IQueryableTimestamp[];
  groupByOptions: IGroupBySection[];
  availableColumns: IColumnSection[];
  availableCharts: IChartFilter<ICustomChartSettings>[];
  defaultColumns: ReportingReference[];
  staticFilters: ICustomReportFilter[];
  scopes: TemplateScope[];
  scopeDataAccessor: ScopeDataAccessorMap;
}

export interface IGroupBySection {
  name: string;
  options: IGroupBySectionOption[];
}

export interface IGroupBySectionOption {
  measure: ICanGroupMeasuresProperty;
  compatibleReducers: MeasureReducer[];
}

export interface IColumnSection {
  name: string;
  columns: ICustomReportDefinedColumn[];
}
